import { render } from "./AnchorsMenu.vue?vue&type=template&id=265b1866&scoped=true"
import script from "./AnchorsMenu.vue?vue&type=script&lang=js"
export * from "./AnchorsMenu.vue?vue&type=script&lang=js"

import "./AnchorsMenu.vue?vue&type=style&index=0&id=265b1866&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265b1866"]])

export default __exports__